export { IonWrapperComponent } from './ion-wrapper';
export { IonWrapperModule } from './ion-wrapper.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts